import PropTypes from 'prop-types';
import React from 'react';
import { Typography, Button } from '@sm/wds-react';

import PACKAGE_SUMMARY_FEATURES from '../../pricingdata/package-features';

import './package.scss';

function packageLabelToClassName(labelName) {
  return labelName
    .trim()
    .replace(/\s/g, '-')
    .toLowerCase();
}

const Package = ({ details, skuCost, package: packageName }) => {
  const coreSeatCost = skuCost.find(
    sku => sku.skuType === 'SUBSCRIPTION_CORE_SEAT'
  );
  const packageClassName = packageLabelToClassName(details.label);
  const monthlyCostInDollars = parseInt(coreSeatCost.cost, 10) / 100 / 12;
  const features = PACKAGE_SUMMARY_FEATURES[packageName] || [];

  return (
    <article className="sm-package" key={packageName}>
      <header
        className={`sm-package__header sm-package--border-${packageClassName}`}
      >
        <Typography
          component="h1"
          variant="sectionTitle"
          className="sm-package__title"
        >
          {details.displayName}
        </Typography>
        <Typography component="h2" variant="cardTitle">
          <Typography component="span" variant="pageTitle">
            {`$${monthlyCostInDollars}`}
          </Typography>
          {' / month'}
        </Typography>
        <Typography component="h3" variant="body">
          {'Starting at 3 users, billed annually'}
        </Typography>
        <Button
          className={`sm-package__btn sm-package__btn--${packageClassName}`}
          href="/user/sign-up"
          stretched
        >
          SIGN UP
        </Button>
      </header>
      <section
        className={`sm-package__details sm-package--border-${packageClassName}`}
      >
        <ul className="sm-package__feature-list">
          {features.map(feature => {
            return (
              <li
                className="sm-package__feature"
                key={`${packageName}-feature-${feature.summaryLine}`}
              >
                {feature.summaryLine}
              </li>
            );
          })}
        </ul>
      </section>
      <footer className="sm-package__footer">
        <Button
          className={`sm-package__btn sm-package__btn--${packageClassName}`}
          href="/user/sign-up"
          stretched
        >
          SIGN UP
        </Button>
      </footer>
    </article>
  );
};

Package.propTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  skuCost: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired
    })
  ).isRequired,
  package: PropTypes.string.isRequired
};

export default Package;
